<template>
  <div class="wt2-base-panel" :class="type">
    <wt-button
      class="wt2-base-panel-hide-button -hover-blue wt2-text-n wt2-color-negative -custom -min-width-unset -remove-hover-background"
      type="transparent"
      text="Hide"
      @click="onHide"
    ></wt-button>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'normal',
    },

    onHide: {
      type: Function,
      required: true,
    },
  },
};
</script>
